import Vue from 'vue'
import Vuex from 'vuex'

import mutations from './mutations'
import getter from './getter'
import actions from './actions'

Vue.use(Vuex)
const store = new Vuex.Store({
	state:{
		debug:false,
		orgId:'',	//院校id（每个接口都加上）
		apiUrl:'',
		//apiUrl:'http://235b66690v.51mypc.cn:58211',
		//apiUrl:'http://www.qxcourse.com/jxedu_admin_api',
		token:'',
		nowRouteName:'',	//当前路由名称
		isMobile:false,	//是否移动端

		navList:null,		//PC端导航
		nowNavCode:1001,	//当前导航展示的code	
		nowNavId:'',			//当前导航展示的栏目id（栏目才用到）
		
		headerHeight:0,	//头部高度
		footerHeight:0,	//尾部高度
		
	},
	mutations,
	getter,
	actions
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js